import { render, staticRenderFns } from "./myCertification.vue?vue&type=template&id=28feea80&scoped=true"
import script from "./myCertification.vue?vue&type=script&lang=js"
export * from "./myCertification.vue?vue&type=script&lang=js"
import style0 from "./myCertification.vue?vue&type=style&index=0&id=28feea80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28feea80",
  null
  
)

export default component.exports